var scrollTop = function () {
        $("html, body").animate({ scrollTop: 0 }, "fast");
    },
    objResize = function () {
        if ($("#flashcontainer").length > 0) {
            var fullsize = $("#flashcontainer").width();
            $("object").width(fullsize).height(Math.ceil(fullsize * 0.73));
        }
    },
    chkFB = function () {
        var person = $("#name").val(),
            email = $("#mail").val(),
            contact = $("#other").val(),
            sub = $("#subject").val(),
            returnval = true;
        if (person === "") {
            returnval = false;
            $("#personmsg").slideDown("slow");
        } else {
            $("#personmsg").slideUp("slow");
        }
        if (email === "") {
            returnval = false;
            $("#emailmsg").slideDown("slow");
        } else {
            $("#emailmsg").slideUp("slow");
        }
        if (contact === "") {
            returnval = false;
            $("#othermsg").slideDown("slow");
        } else {
            $("#othermsg").slideUp("slow");
        }
        if (sub === "") {
            returnval = false;
            $("#submsg").slideDown("slow");
        } else {
            $("#submsg").slideUp("slow");
        }
        return returnval;
    },

    resetPassword = function (ev) {
        console.log('resetPassword');
        var form = ev.target,
            userInput = $(form).find('input[type=text]')[0].value;

        ev.preventDefault();

        if (/^[a-z\-_\.\@]{3,}$/i.test(userInput)) {
            $.post('/task/reset', {
                user: userInput
            }, onResetPassword);
        } else {
            alert('Invalid input.');
        }

        return false;
    },

    onResetPassword = function (responseObject) {
        console.log('onResetPassword');
        if (responseObject.success) {
            $("#passwordResetForm").html('Password reset email sent. Please check your inbox shortly.');
        } else {
            alert('An error occurred while attempting to reset your password. Please try again or contact support.');
        }
    };

const scrollHeader = (element) => {
  const className = "hide-on-scroll";
  const offset = 48;

  let direction = "";
  let lastY = null;
  let isPastOffset = false;

  const onScroll = () => {
    const { scrollY } = window;

    isPastOffset = scrollY > offset;

    direction = scrollY > lastY ? "down" : "up";

    element.classList.toggle(className, isPastOffset && direction === "down");

    lastY = scrollY;
  };

  window.addEventListener("scroll", onScroll, { passive: true });
};

$(document)
    .on("click", "#toggle-menu", function () {
        $('#navigation').toggleClass('open');
        return false;
    })
    .on("click", ".removebtn", function () {
        var gourl = $(this).attr("href");
        $(this).parent("li").load(gourl);
        return false;
    })
    .on("click", ".toggler", function () {
        var $target = $(this).attr("data-target");
        $(this).slideUp("fast");
        $("#" + $target).slideDown("fast");
    })
    .on("click", "#controls .addbtn", function () {
        var myurl = $(this).attr("href");
        $(this).parent("p").load(myurl + "&ajax=1");
        return false;
    })
    .on("click", "#solveme", function () {
        var pnum = $(this).data("pid");
        $.post("/" + pnum + "/mark", { 'ajax': 1 }, function (data) {
            if (data === "1") {
                $("#solveme").addClass("active");
            } else { $("#solveme").removeClass("active"); }
        });
        return false;
    })
    .on("click", "#faveme", function () {
        var pnum = $(this).data("pid");
        $.post("/" + pnum + "/fave", { 'ajax': 1 }, function (data) {
            if (data === "1") {
                $("#faveme").addClass("active");
            } else { $("#faveme").removeClass("active"); }
        });
        return false;
    })
    .on("click", "#emailSubmit", function () {
        if ($("#addy").val() === "") {
            $("#updatemsg").slideDown("slow");
        } else {
            $("#updatemsg").slideUp("slow");
        }
        return ($("#addy").val() !== "");
    })
    .on("click", "#topbtn", scrollTop);

$(window).on('resize', objResize);

$(function () {
    $("#passwordResetForm").on("submit", resetPassword);
    if ($(".lb").length > 0) {
        $("<div id='lb'><img /></div>").insertAfter("#footer");
        $("#lb").click(function () { $(this).fadeOut("fast"); });
        $(".lb li a").click(function () {
            var imgsrc = $(this).attr("href");
            $("#lb img").attr("src", imgsrc);
            $("#lb").fadeIn("fast");
            return false;
        });
    }
    objResize();
    if (top !== self) {
        $("#teasemsg").hide();
        $("#framealert")
            .show()
            .click(function () {
                top.location.replace(self.location.href);
            });
    }
    if ($("#keyBtn").length > 0) {
        var keyUrl = $("#keyBtn").attr("href"),
            keyType = keyUrl.substring(keyUrl.length - 4, keyUrl.length).toLowerCase();
        switch (keyType) {
            case ".txt":
                $("#spoiler").load(keyUrl);
                $("#keyBtn").text("Display Answer Key").click(function () { $("#spoiler").slideToggle("slow"); return false; });
                break;
            case ".png":
            case ".gif":
            case ".jpg":
                $("#spoiler").html("<img src=\"" + keyUrl + "\" alt=\"Answer Key\" />");
                $("#keyBtn").text("Display Answer Key").click(function () { $("#spoiler").slideToggle("slow"); return false; });
                break;
            default:
                $("#spoiler").remove();
                break;
        }
    }

    scrollHeader(document.getElementById('navigation'));
});
